import {
  sendNotification,
  useEntityMetadata,
  useModuleBaseMetadata,
  useModuleFederationContext,
  useTranslation,
} from '@msdk/common'
import { EntityMetadata } from '@msdk/definitions'
import React, { useEffect, useState } from 'react'

interface Props {
  entityName: string
  editForm: string
  children: React.ReactElement
}

export function EmbeddedEntityViewFederationWrapper(props: Props) {
  const { ensureModule, loadedModules } = useModuleFederationContext()
  const entityModel = useEntityMetadata(props.entityName)
  const baseMetadata = useModuleBaseMetadata(props.entityName, props.editForm) as EntityMetadata | undefined
  const [msOK, setMsOk] = useState(false)
  const t = useTranslation()

  useEffect(() => {
    if (baseMetadata) {
      ensureModule(props.entityName, props.editForm, baseMetadata.msProvider, entityModel, true)
      setMsOk(true)
    } else {
      setMsOk(false)
      sendNotification({
        message: t('NOT_FOUND_MS_METADATA_ERROR', 'Some data was not able to be loaded, a microservice is missing'),
        status: 'error',
      })
    }
  }, [])

  const isModuleLoaded = baseMetadata ? !!loadedModules[baseMetadata.msProvider] : false

  return <>{isModuleLoaded && msOK && props.children}</>
}
